
export default  [
   
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        field: 'descricao',
        label: 'Descrição',
        maxlength:300,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'upload',
        field: 'arquivo',
        multiple:false,
        accept: '.jpg, .png, .jpeg, .pdf, .zip',
        label: 'Selecione o Arquivo - Até 50 MB (imagem,pdf,zip)',
        info:'Caso precisar fazer upload de mais de um arquivo, você pode compactar esses arquivos no formato ZIP e fazer upload do arquivo compactado.',
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/ltcat/anexo/_form/equipamento-cadastrar.js